/**
 * Generated runtime TestId mirror for frontend/src/pages/OnboardingWizard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const OnboardingWizardTestIds = {
  btnCancel: "btn-cancel",
  btnNext: "btn-next",
  btnPrevious: "btn-previous",
  btnSubmit: "btn-submit",
  onboardingWizardPage: "onboarding-wizard-page",
  wizardStep: (step: string) => `wizard-step-${step}`,
  wizardStepPrefix: () => "wizard-step-" as TestIdPrefix
} as const;
